// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YJCbl","colBig":"styles_colBig__1t6Np","colSmall":"styles_colSmall__1yaLn"};